import { Hive, hiveSchema } from "@fatbees/schemas";

export async function putHive(hive: Hive): Promise<void> {
  const response = await fetch(`/api/hives/${encodeURIComponent(hive.id)}`, {
    method: "PUT",
    body: JSON.stringify({
      name: hive.name,
      retiredAt: hive.retiredAt,
      loadId: hive.loadId,
    }),
    headers: { "content-type": "application/json" },
    credentials: "same-origin",
  });
  if (!response.ok) {
    throw new Error(response.statusText);
  }
  hiveSchema.parse(await response.json());
}

export async function deleteHive(hive: Hive): Promise<void> {
  const response = await fetch(`/api/hives/${encodeURIComponent(hive.id)}`, {
    method: "DELETE",
    credentials: "same-origin",
  });
  if (!response.ok) {
    throw new Error(response.statusText);
  }
}
